import React, { useEffect, useState } from 'react';

import { Container, Pagination } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import classes from './NgzCustomersDashboardScanIq.module.scss';
import { TitleRow } from './TItleRow/TitleRow';
import { angularizeWithProviders } from '../../../shared/providers';
import {
  completedScanIqCustomerListStore,
  needSetupScanIqCustomerListStore,
} from '../../stores/scanIqCustomersListStore';
import { useScanIqCustomerListStore } from './hooks/useScanIqCustomerListStore';
import { SETUP_STATUS, SetupStatusTab } from '../../interfaces/ScanIqCustomerSetupInfo';
import { FilterRow } from './FilterRow/FilterRow';
import { EmptyList, PageTitle } from '../../../shared/components/ui-components';
import { CustomerRow } from './CustomerRow/CustomerRow';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import { AddNewScanIqCustomerButton } from './AddNewScanIqCustomerButton/AddNewScanIqCustomerButton';
import { CustomersTabs } from './CustomersTabs/CustomersTabs';

const NgzCustomersDashboardScanIq = observer(() => {
  const [setupStatus, setSetupStatus] = useState<SetupStatusTab>(SETUP_STATUS.COMPLETED);

  const store = useScanIqCustomerListStore(setupStatus);
  const { customerList, filterMethods } = store;
  const { isSuperAdmin } = loggedInUserDataStore;

  const {
    totalElements,
    isShowPagination,
    isShowPlaceholder,
    isSearchUsed,
    getPaginationProps,
  } = filterMethods;

  useEffect(() => {
    completedScanIqCustomerListStore.getCustomerList();
    needSetupScanIqCustomerListStore.getCustomerList();

    return () => {
      completedScanIqCustomerListStore.setDefaultValues();
      needSetupScanIqCustomerListStore.setDefaultValues();
    };
  }, []);

  const tableClassNames = classNames(classes.customersTable, {
    [classes.extraColumn]: isSuperAdmin,
  });

  const paginationProps = getPaginationProps();

  return (
    <Container>
      <PageTitle
        title={`Customer Communication (${totalElements})`}
        tabs={<CustomersTabs value={setupStatus} onValueChange={setSetupStatus} />}
      >
        <AddNewScanIqCustomerButton />
      </PageTitle>
      <div className={tableClassNames}>
        <TitleRow setupStatus={setupStatus} />
        {/* key remounts the form so it re-inits from the active tab's stored filters */}
        <FilterRow key={setupStatus} setupStatus={setupStatus} />
        {customerList.map((customer) => (
          <CustomerRow
            key={`${customer.id}-${customer.entityId}`}
            customerInfo={customer}
          />
        ))}
      </div>
      <EmptyList
        show={isShowPlaceholder}
        isSearch={isSearchUsed}
        description="There are no customers"
      />
      {isShowPagination && <Pagination {...paginationProps} />}
    </Container>
  );
});

angularizeWithProviders(NgzCustomersDashboardScanIq, 'ngzCustomersDashboardScanIq', {});
